import { render, staticRenderFns } from "./EmailResetPwd.vue?vue&type=template&id=3768810e&"
import script from "./EmailResetPwd.vue?vue&type=script&lang=js&"
export * from "./EmailResetPwd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/tempos21/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('3768810e', component.options)
    } else {
      api.reload('3768810e', component.options)
    }
    module.hot.accept("./EmailResetPwd.vue?vue&type=template&id=3768810e&", function () {
      api.rerender('3768810e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Pages/Login/EmailResetPwd.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/Pages/Login/EmailResetPwd.vue
// module id = ZkMj
// module chunks = 0